import { cn } from '@baseball-near-you/ui';
import type { ReactNode } from 'react';

export function Container(props: { children: ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        'mt-4 h-full w-full max-w-7xl px-4 md:px-6 lg:px-12',
        props.className
      )}
    >
      {props.children}
    </div>
  );
}
